import { allowedFileTypes } from '../../../../../backend/src/matter/doc/allowed-extensions';
import { Icon } from '../icon';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../shadcn/dialog';

interface PermittedFileTypesModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function PermittedFileTypesModal({ open, onOpenChange }: PermittedFileTypesModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Icon className="lucide--file-check" />
            Permitted file types
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-4">
          <p className="text-gray-700">Wexler supports the following file types:</p>
          <div className="flex flex-wrap gap-x-4 gap-y-2 rounded-md border bg-gray-50 p-3">
            {allowedFileTypes.map((fileType: string) => (
              <div className="rounded-md border bg-gray-100 px-2 py-1 text-xs font-medium text-gray-700" key={fileType}>
                {fileType}
              </div>
            ))}
          </div>
          <ul className="flex list-inside list-disc flex-col gap-2 py-2 text-sm text-gray-700">
            <li>The maximum file size supported is 3GB</li>
            <li>The maximum number of files supported is 100,000</li>
          </ul>
          <p className="text-xs text-gray-600">
            Reach out to the Wexler team if these limits are not sufficient for your case.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
